// Code generated by pkg/router_helper/make_api.go, DO NOT EDIT.

import { fetchApi } from '../fetchApi'

import * as Types from './type'

export const taskApi = {
  countUnRead: {
    method: 'post',
    path: '/api-bff/user/task/countUnRead',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
  file: {
    method: 'post',
    path: '/api-bff/user/task/file',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
  page: {
    method: 'post',
    path: '/api-bff/user/task/page',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
  read: {
    method: 'post',
    path: '/api-bff/user/task/read',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
}

export function page(body: Types.UserExportTaskPageReqDTO, ...args: any): Promise<Types.OneClubBasePageResponse_UserExportTaskDTO> {
  return fetchApi(taskApi.page as any, body, ...args) as Promise<Types.OneClubBasePageResponse_UserExportTaskDTO>
}

export function countUnRead(body: Types.OneClubBaseReqDTO, ...args: any): Promise<Types.UserExportTaskCountUnReadRespDTO> {
  return fetchApi(taskApi.countUnRead as any, body, ...args) as Promise<Types.UserExportTaskCountUnReadRespDTO>
}

export function read(body: Types.UserExportTaskReadReqDTO, ...args: any): Promise<boolean> {
  return fetchApi(taskApi.read as any, body, ...args) as Promise<boolean>
}

export function file(body: Types.UserExportFileRequest, ...args: any): Promise<Types.UserExportFileResponse> {
  return fetchApi(taskApi.file as any, body, ...args) as Promise<Types.UserExportFileResponse>
}
